
import { createClient } from '@supabase/supabase-js';
import { Database } from '@/types/supabase';

const supabaseUrl = 'https://ypmquaodcjfzclhiedui.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlwbXF1YW9kY2pmemNsaGllZHVpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM4NjMzNTEsImV4cCI6MjA1OTQzOTM1MX0._3tCRjfEfEBuZLUT5Mdt0xHhCYkfMfVX5Gmp87HDVkQ';

/**
 * The base path - consistently empty to ensure proper routing
 */
export const basePath = '';

/**
 * The canonical URL - dynamically determined at runtime for flexibility
 * With specific handling for baabaa.app
 */
export const canonicalUrl = typeof window !== 'undefined' 
  ? window.location.origin 
  : 'https://baabaa.app';

// Enhanced logging for URL configuration
if (typeof window !== 'undefined') {
  console.log('Supabase client: Using origin:', window.location.origin);
  console.log('Supabase client: Full URL:', window.location.href);
  console.log('Supabase client: Pathname:', window.location.pathname);
  console.log('Supabase client: Hash:', window.location.hash);
  console.log('Supabase client: Search:', window.location.search);
  console.log('Supabase client: Hostname:', window.location.hostname);
  
  // Check if we're on baabaa.app
  if (window.location.hostname === 'baabaa.app' || window.location.hostname.endsWith('.baabaa.app')) {
    console.log('Supabase client: Detected baabaa.app domain');
  }
}

export const supabase = createClient<Database>(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storageKey: 'supabase.auth.token',
    storage: typeof window !== 'undefined' ? localStorage : undefined,
  },
  global: {
    headers: {
      'X-Client-Info': 'beam-evaluate'
    }
  }
});

// Export additional debug function
export const getDebugInfo = () => {
  return {
    env: process.env.NODE_ENV,
    origin: typeof window !== 'undefined' ? window.location.origin : 'SSR',
    pathname: typeof window !== 'undefined' ? window.location.pathname : 'unknown',
    fullUrl: typeof window !== 'undefined' ? window.location.href : 'unknown',
    hostname: typeof window !== 'undefined' ? window.location.hostname : 'unknown',
    basePath,
    canonicalUrl
  };
};
